<!-- MIGRATED VUE 3  -->
<template>
  <div class="eventSnackbar" data-testid="socio-base-notification">
    <VSnackbar
      v-for="(snackbarElement, index) in snackbarElements"
      ref="snackbars"
      :key="index"
      :model-value="snackbarElement.display"
      :timeout="snackbarElement.timeout"
      multi-line
      :style="{ top: arrayOfTop[index] }"
      :color="snackbarElement.color"
      v-bind="{ [position(snackbarElement.position)]: true }"
      location="top"
      @update:model-value="$emit('snackbarElements', snackbarElements)"
    >
      <VRow no-gutters align="center" justify="space-between">
        <VCol cols="9">
          <h2 v-if="snackbarElement.title" class="text-white ma-0" style="font-size: 16px">
            {{ te(snackbarElement.title) ? t(snackbarElement.title) : snackbarElement.title }}
          </h2>
          <p class="text-white ma-0">
            {{ te(snackbarElement.text) ? t(snackbarElement.text) : snackbarElement.text }}
          </p>
        </VCol>
        <VCol cols="3">
          <VRow justify="end">
            <VBtn variant="text" @click="closeSnackbar(index)">
              {{ t("close") }}
            </VBtn>
          </VRow>
        </VCol>
      </VRow>
    </VSnackbar>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import isEqual from "lodash/isEqual";
import { useNotificationsStore } from "@/store/notification";

const emit = defineEmits(["snackbarElements"]);

const notificationsStore = useNotificationsStore();
const { t, te } = useI18n();

/* List of object representing vuetify snackbar element.
 * keys: display, timeout, color, title, text
 * */
const snackbarElements = ref([]);
// Array used to specified the top value of snackbar
const arrayOfTop = ref(["30px"]);
const snackbarRefs = ref(null);

const getLastNotification = computed(() => notificationsStore.getLastNotification);

//Recalculate the top when a snackbar is added or deleted
watch(snackbarElements, () => {
  arrayOfTop.value = ["30px"];
  if (!snackbarRefs.value) {
    return;
  }

  snackbarRefs.value.forEach((snackbar) => {
    const rect = snackbar.$el.getBoundingClientRect();
    arrayOfTop.value.push(`${rect.top + snackbar.$el.clientHeight}px`);
  });
});

//Listen for a new notification
watch(getLastNotification, (lastNotification) => {
  if (!lastNotification) {
    return;
  }

  const snackbarElementToAdd = {
    ...lastNotification,
    display: true,
    timeout: -1,
  };

  notificationsStore.setLastNotification(null);

  snackbarElements.value.push(snackbarElementToAdd);
  emit("snackbarElements", snackbarElements.value);

  // Dont delete notification if infinite timeout
  if (lastNotification.timeout !== -1) {
    setTimeout(() => {
      findAndDeleteSnackbarElement(snackbarElementToAdd);
    }, lastNotification.timeout || 6000);
  }
});

const findAndDeleteSnackbarElement = (snackbarElement) => {
  for (let i = 0; i < snackbarElements.value.length; i++) {
    if (isEqual(snackbarElements.value[i], snackbarElement)) {
      snackbarElements.value.splice(i, 1);
      break;
    }
  }
  emit("snackbarElements", snackbarElements.value);
};

const closeSnackbar = (index) => {
  snackbarElements.value.splice(index, 1);
  emit("snackbarElements", snackbarElements.value);
};

const position = (position) => {
  if (position === "left" || position === "center") {
    return position;
  } else {
    return "right";
  }
};
</script>
